import CheckInCheckOutList from "../../Common/CheckInCheckOutList";
import { formatDate } from "../../../utils/CommonUtils";

const CheckInCheckOutModal = ({
    selectedCalendarZoneId,
    zoneList,
    checkInCheckOutRecords,
    setCheckInCheckOutRecords,
    selectedZoneId,
    isLoading,
    setShowModal,
    selectedDate,
    setIsLoading,
    fetchBookings,
    handleApiUiResponse,
    recordsData,
    mapAvailable,
}) => {
    return (
        <CheckInCheckOutList
            ZoneId={selectedCalendarZoneId}
            zoneName={zoneList?.find((z) => z.Id === selectedCalendarZoneId)?.ZoneName}
            checkInCheckOutRecords={checkInCheckOutRecords}
            setCheckInCheckOutRecords={setCheckInCheckOutRecords}
            selectedZoneId={selectedZoneId}
            isLoading={isLoading}
            closeModal={() => {
                setShowModal(false);
            }}
            selectedDate={checkInCheckOutRecords?.[0]?.BookingDate || selectedDate}
            onCheckInCheckout={async (zoneId, bookingDateStr) => {
                setIsLoading(true);
                try {
                    await fetchBookings(
                        zoneId ?? selectedCalendarZoneId,
                        bookingDateStr ?? checkInCheckOutRecords?.[0]?.BookingDate ?? formatDate(selectedDate)
                    );
                } finally {
                    setIsLoading(false);
                }
            }}
            onCheckInApiResponse={async ({ response, zoneId, bookingDateStr, closeModal }) => {
                const responseCode = Number(response?.Data?.ResponseCode);

                if (responseCode !== 449) {
                    return;
                }

                closeModal();
                handleApiUiResponse(response, {
                    successToaster: 0,
                    errorToaster: 0,
                    alertPopup: 1,
                    onConfirmByCode: {
                        449: async () => {
                            setIsLoading(true);
                            try {
                                await fetchBookings(
                                    zoneId ?? selectedCalendarZoneId,
                                    bookingDateStr ?? checkInCheckOutRecords?.[0]?.BookingDate ?? formatDate(selectedDate)
                                );
                            } finally {
                                setIsLoading(false);
                            }
                        }
                    }
                });
            }}
            mapAvailableType={recordsData?.MapType}
            mapAvailable={mapAvailable}
        />
    );
};

export default CheckInCheckOutModal;
